import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAVAifjkmj9c06o_SjjcCDWZuW561q5_XY",
  authDomain: "mnrhub-e4a87.firebaseapp.com",
  projectId: "mnrhub-e4a87",
  storageBucket: "mnrhub-e4a87.appspot.com",
  messagingSenderId: "848644380385",
  appId: "1:848644380385:web:aab43706079dc465e309a0"
};

// Initialize Firebase

const app =  firebase.default.initializeApp(firebaseConfig);
export const storage = getStorage(app);


